import { render, staticRenderFns } from "./supplierLogisticsChannels.vue?vue&type=template&id=6e9de554&scoped=true"
import script from "./supplierLogisticsChannels.vue?vue&type=script&lang=js"
export * from "./supplierLogisticsChannels.vue?vue&type=script&lang=js"
import style0 from "./supplierLogisticsChannels.vue?vue&type=style&index=0&id=6e9de554&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9de554",
  null
  
)

export default component.exports